import {
    useEffect,
    useState
} from "react";
import config from "../../config/config";

function GenericPhoneSearch({
    prefixLabel,
    phoneNumber,
    apiEndpoint,
    messageCallback,
    onResultUpdate
}) {
    const [isLoading, setIsLoading] = useState(true);
    const [result, setResult] = useState({
        status: "",
        message: "Loading, Please Wait!"
    });

    async function fetchData() {
        setIsLoading(true);
        const axios = require("axios").default;
        try {
            let url = apiEndpoint + phoneNumber;

            const response = await axios.get(`${url}`, {
                headers: {
                    "Access-Control-Allow-Origin": "no-cors",
                    ApiKey: config.API_KEY,
                },
            });

            let resultValue;
            if (messageCallback) {
                resultValue = messageCallback(response);
                setResult(resultValue);
            } else {
                resultValue = {
                    status: response.data ? 'found' : 'safe',
                    message: `${phoneNumber} is ${JSON.stringify(response.data)}`
                };
                setResult(resultValue);
            }
            
            // Call onResultUpdate callback if provided
            if (onResultUpdate) {
                onResultUpdate(resultValue);
            }
        } catch (error) {
            const errorResult = {
                status: "",
                message: `Error: ${error.message || JSON.stringify(error)}`
            };
            setResult(errorResult);
            if (onResultUpdate) {
                onResultUpdate(errorResult);
            }
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        // When phone number changes, reset state before fetching
        setIsLoading(true);
        setResult({
            status: "",
            message: "Loading, Please Wait!"
        });
        
        // Let parent component know we're in loading state
        if (onResultUpdate) {
            onResultUpdate({
                status: "",
                message: "Loading, Please Wait!"
            });
        }
        
        // Start data fetch
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [phoneNumber]);

    return (
        <div style={{ 
            margin: '5px 0', 
            textAlign: 'center', 
            lineHeight: '1.5',
            padding: '10px',
            borderRadius: '4px',
            fontWeight: '700',
            background: isLoading ? '#f9f9f9' : 
                     result.status === 'safe' ? '#ebfaeb' : 
                     result.status === 'found' ? '#ffebeb' : '#ffffff',
            border: isLoading ? '1px solid #f0f0f0' : 
                    result.status === 'safe' ? '1px solid #c3e6cb' : 
                    result.status === 'found' ? '1px solid #f5c6cb' : '1px solid #f0f0f0'
        }}>
            <span style={{ 
                color: '#e63946', 
                fontWeight: 'bold'
            }}>
                {prefixLabel}
            </span>
            {isLoading ? 
                <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                    <div className="loader loader-small" style={{ marginRight: '8px' }}></div> Loading...
                </span> : 
                <span style={{ 
                    color: result.status === 'safe' ? '#28a745' : 
                           result.status === 'found' ? '#dc3545' : '#000000'
                }}>
                    {result.message}
                </span>
            }
        </div>
    );
}
export default GenericPhoneSearch;